<app-hero-banner
  [title]="'contact us'"
  [isFullBanner]="false"
  [imgPath]="'../../assets/hi-res/banner.png'"
></app-hero-banner>
<div class="container">
  <div class="header">
    <h1>message us</h1>
    <p>
      For new enquiries, please fill out the form and we'll be in touch within
      48 hours.
    </p>
  </div>

  <div
    class="form-container"
    #formContainer
    [ngClass]="{ isError: submissionError }"
  >
    @if (!formSubmitted && submissionError || !submissionError &&
    !formSubmitted) {
    <form
      [formGroup]="contactForm"
      (ngSubmit)="onSubmit()"
      class="fade-in-form"
    >
      <div>
        <label for="name">Name:</label>
        <input
          type="text"
          id="name"
          formControlName="name"
          placeholder="John Doe"
          required
        />
      </div>

      <div>
        <label for="email">Email:</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          placeholder="johndoe@email.co.uk"
          required
        />
      </div>

      <div>
        <label for="phone">Phone:</label>
        <input
          type="text"
          id="phone"
          formControlName="phone"
          placeholder="01234567890"
          required
        />
      </div>

      <div>
        <label for="location">Location:</label>
        <input
          type="text"
          id="location"
          formControlName="location"
          placeholder="London"
          required
        />
      </div>

      <div>
        <label for="location">Desired Timescale:</label>
        <input
          type="text"
          id="timescale"
          formControlName="timescale"
          placeholder="End of September"
          required
        />
      </div>

      <div>
        <label for="enquiry">Your Enquiry:</label>
        <textarea
          id="enquiry"
          formControlName="enquiry"
          rows="4"
          required
        ></textarea>
      </div>

      <div>
        <label>Services:</label>
        <div class="checkbox-group" formArrayName="services">
          <div
            *ngFor="let service of servicesFormArray.controls; let i = index"
          >
            <input type="checkbox" [id]="'service' + i" [formControlName]="i" />
            <label [for]="'service' + i">{{ servicesOptions[i] }}</label>
          </div>
        </div>
      </div>

      <div>
        <label>Upload images:</label>
        <div
          class="upload-images"
          *ngIf="!fileLimitReached"
          (click)="fileInput.click()"
          (dragover)="onDragOver($event)"
          (drop)="onDrop($event)"
        >
          <i class="fa fa-cloud-upload" aria-hidden="true"></i>
          <p>Click to upload photos or drag and drop</p>
          <p>Maximum 3 files up to 10mb total</p>
        </div>

        <!-- Max Files Message -->
        <div *ngIf="fileLimitReached" class="file-limit-message">
          <p>You have reached the maximum of {{ maxFiles }} uploaded images.</p>
        </div>

        <input
          type="file"
          #fileInput
          (change)="onFileSelected($event)"
          multiple
          accept="image/*"
          style="display: none"
        />

        <div class="file-preview" *ngIf="uploadedFiles.length">
          <p>Uploaded Images:</p>
          <ul>
            <li *ngFor="let uploadedFile of uploadedFiles; let i = index">
              {{ uploadedFile.uniqueFileName }}
              ({{ uploadedFile.file.size / 1000000 | number : "1.2-2" }}
              MB)
              <button
                type="button"
                (click)="removeFile(i)"
                class="remove-file-btn"
              >
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>

      <!-- Submit Button -->
      <button type="submit" [disabled]="contactForm.invalid || isLoading">
        Submit
      </button>

      <!-- Loading Spinner -->
      @if (isLoading) {
      <div>Submitting...</div>
      }

      <!-- Success Message -->
      @if (formSubmitted && !isLoading) {
      <div>Thank you! Your enquiry has been submitted.</div>
      }
    </form>
    }

    <!-- Success Message -->
    @if (formSubmitted) {
    <div class="success-message fade-in-message">
      <div class="success-icon">
        <i class="fa fa-check-circle"></i>
      </div>
      <h2>Thank you for reaching out!</h2>
      <p>Your form has been submitted. Our team will get back to you soon.</p>
    </div>
    }

    <!-- Error Message -->
    @if (submissionError) {
    <div class="error-message fade-in-message">
      <div class="error-icon">
        <i class="fa fa-times-circle"></i>
      </div>
      <h2>Oops! Something went wrong.</h2>
      <p>There was an issue submitting your form. Please try again.</p>
      <button (click)="resetFormState()">Try Again</button>
      <!-- Reset the form to allow resubmission -->
    </div>
    }
  </div>

  <div class="card-container">
    <div class="form-title">
      <h1>Contact Us</h1>
      <p>For any other matters</p>
    </div>

    <div class="contact-grid">
      <div class="contact-card">
        <div class="icon-container">
          <i class="fa-brands fa-instagram"></i>
        </div>
        <h3>Via Instagram</h3>
        <p>For any enquiries</p>
        <a href="https://www.instagram.com/bournebespoke" target="_blank">
          <button mat-button class="contact-button">View our page</button>
        </a>
      </div>

      <div class="contact-card">
        <div class="icon-container">
          <i class="fa-regular fa-comments"></i>
        </div>
        <h3>Contact aftercare</h3>
        <p>We’re here to help.</p>
        <a href="mailto: aftercare@bournebespoke.com">
          <button mat-button class="contact-button">Contact support</button>
        </a>
      </div>

      <div class="contact-card">
        <div class="icon-container">
          <i class="fa-solid fa-phone"></i>
        </div>
        <h3>Call us</h3>
        <p>Mon-Fri from 8am to 5pm.</p>
        <a href="tel:+447512371898">
          <button mat-button class="contact-button">Call our team</button>
        </a>
      </div>

      <div class="contact-card">
        <div class="icon-container">
          <i class="fa-solid fa-map-pin"></i>
        </div>
        <h3>Visit us</h3>
        <p>Visit our showroom</p>
        <a href="https://maps.app.goo.gl/JNv8JR5oGcSTqKKz9" target="_blank">
          <button mat-button class="contact-button">Get directions</button>
        </a>
      </div>
    </div>
  </div>
</div>
